module.exports = __webpack_public_path__ + "img/2.cd252a0b.jpg";